import { Gift } from "lucide-react";

import { createNavigationLucideIcon } from "./createNavigationLucideIcon";

export const GiftIcon = createNavigationLucideIcon(Gift);
